import type { MeResponse } from '../../entities/me/me-contract.types';

/** Имя/slug организации для UI: пусто, «Организация #N» и одно слово «Организация» не считаются отображаемым именем. */
export function readableOrganizationNameCandidate(raw: string | null | undefined): string | null {
  const t = (raw ?? '').trim();
  if (!t) return null;
  if (isLegacyNumericOrgPlaceholder(t)) return null;
  if (t === 'Организация') return null;
  return t;
}

/** Устаревший плейсхолдер вида «Организация #12» — не считать именем. */
export function isLegacyNumericOrgPlaceholder(name: string | null | undefined): boolean {
  return /^Организация\s*[#№]\s*\d+$/i.test((name ?? '').trim());
}

/** Имя организации из снимка `/auth/me` (memberships / organizations). */
export function orgDisplayNameFromMe(me: MeResponse | null | undefined, organizationId: number): string | null {
  if (!me) return null;
  const o = me.organizations?.find((x) => x.id === organizationId);
  const on = readableOrganizationNameCandidate(o?.name ?? null);
  if (on) return on;
  const os = readableOrganizationNameCandidate(o?.slug ?? null);
  if (os) return os;
  const m = me.memberships?.find((x) => x.organization_id === organizationId);
  const mn = readableOrganizationNameCandidate(m?.organization_name ?? null);
  if (mn) return mn;
  const ms = readableOrganizationNameCandidate(m?.organization_slug ?? null);
  if (ms) return ms;
  return null;
}

/** Подпись, когда имя в снимке неизвестно; id в тексте, чтобы не сливалось с префиксом «Организация: …». */
export function orgNeutralLabel(organizationId: number): string {
  return `Организация №${organizationId}`;
}

export function orgNeutralTitle(organizationId: number): string {
  return `ID ${organizationId}`;
}
